// Component.tsx
import React from 'react';
import { HeadlineComponent } from './1-atoms/HeadlineComponent';
import { MediaComponent } from './1-atoms/MediaComponent';
import { ParagraphComponent } from './1-atoms/ParagraphComponent';
import { CampaignModuleComponent } from './2-molecules';
import { NotificationBanner } from './2-molecules/NotificationBanner/NotificationBanner';
import { TileComponent } from './2-molecules/TileComponent/TileComponent';
import { TeaserCard } from './3-organisms/TeaserCardComponent/TeaserCardComponent';
import FormRenderer from './4-habitats/FormRenderer/FormRenderer';
import MessagesComponent from './4-habitats/MessageComponent/MessageComponent';
import MessageListBlock from './4-habitats/MessageListComponent/MessageListComponent';
import PartyComponent from './4-habitats/PartyComponent/PartyComponent';
import PolicyComponent from './4-habitats/PolicyComponent/PolicyComponent';
import PolicyDetailsComponent from './4-habitats/PolicyDetailsComponent/PolicyDetailsComponent';
import PolicyListComponent from './4-habitats/PolicyListComponent/PolicyListComponent';
import { TilesContainer } from './4-habitats/TilesContainer/TilesContainer';

export const Component: React.FC<any> = (props) => {
	//console.log('Component props:', JSON.stringify(props, null, 1));

	const components = {
		PartyBlock: PartyComponent,
		PolicyBlock: PolicyComponent,
		PolicyListBlock: PolicyListComponent,
		PolicyDetailsBlock: PolicyDetailsComponent,
		MessageBlock: MessagesComponent,
		MessageListBlock: MessageListBlock,
		TileBlock: TileComponent,
		TeaserCardBlock: TeaserCard,
		MediaBlock: MediaComponent,
		ParagraphBlock: ParagraphComponent,
		HeadLineBlock: HeadlineComponent,
		GlobalFormContainerBlock: FormRenderer,
		NotificationBlock: NotificationBanner,
		TilesContainerBlock: TilesContainer,
		CampaignModuleBlock: CampaignModuleComponent,
	};

	// Retrieve the React component based on contentType
	const DynamicComponent = components[props?.contentType as keyof typeof components];
	if (props.contentType === 'DefaultContainerBlock') {
		// Handle the DefaultContainerBlock differently or do nothing
		return null; // Do nothing, or render a default placeholder as needed
	} else if (typeof DynamicComponent === 'undefined') {
		// Log an error if the componentType doesn't match any key in the components object
		console.error(`Component [${props.contentType}] is missing a React Component. Check /components/Component.tsx`);
		return (
			<div>{`Component [${props.contentType}] is missing a React Component. Check /components/Component.tsx`}</div>
		);
	}

	// Render the matched component with passed props
	return <DynamicComponent {...props} />;
};
